import DOMPurify from 'dompurify';

/**
 * Tags allowed in HTML written by the AI agents and shown to users: the candidate evaluation
 * (`candidate_evaluations.evaluation_analysis`, FiammellaFormatter in core-services) and the
 * discard motivation (`custom_discard_motivation`, plain text by contract).
 *
 * The formatter contract is h4 + ul/li + p + strong. b, em, i and br show up in production output,
 * u, ol, div and span in older evaluations edited by hand. No attribute is allowed: production
 * texts carry none (checked 29/10/2026), so dropping them changes nothing visible.
 */
export const AI_TEXT_ALLOWED_TAGS = ['h4', 'p', 'ul', 'ol', 'li', 'strong', 'b', 'em', 'i', 'u', 'br', 'div', 'span'];

/**
 * Sanitizes AI-written HTML before it goes into `dangerouslySetInnerHTML`. Anything outside
 * `AI_TEXT_ALLOWED_TAGS` is unwrapped (its text is kept) and every attribute is dropped, so
 * scripts, event handlers, `javascript:` links and iframes never reach the page.
 *
 * DOMPurify needs a DOM: on the server it returns an empty string rather than the raw input.
 * The call sites render on the client (a modal opened by the user), so nothing is lost there.
 */
export const sanitizeAiHtml = (html: string | null | undefined): string => {
  if (!html) return '';
  if (!DOMPurify.isSupported) return '';
  return DOMPurify.sanitize(html, { ALLOWED_TAGS: AI_TEXT_ALLOWED_TAGS, ALLOWED_ATTR: [] });
};
